<template lang="pug">
    layout

        // Main title
        title-component(
            slot="title"
            type="h2"
            :title="$t('programs.edit.title')"
        )

        // Login form
        program-template(action="edit")
</template>

<script>
    import Layout from '../../Layout/Layout';
    import ProgramTemplate from '../ProgramTemplate';
    import Title from '~components/Title';
    import { mapActions } from 'vuex';
    import VueTypes from 'vue-types';

    export default {
        components: {
            Layout,
            ProgramTemplate,
            TitleComponent: Title
        },
        props: {
            id: VueTypes.string.def('')
        },
        created() {
            this.read(this.id);
        },
        methods: {
            ...mapActions('programs', ['read'])
        }
    };
</script>
